/* IV Biotics — mobile floating add-to-cart bar + buy-options bottom sheet.
   The bar is always visible (no scroll needed). With multiple purchase options
   it shows "from <lowest price>" and opens the options popup; with a single
   option it adds straight to cart. Desktop is untouched (the bar/sheet/backdrop
   are display:none above 749px; the inline buy box renders normally). */
(function () {
  function setup(section) {
    var sticky = section.querySelector('[data-ivb-sticky]');
    if (!sticky || sticky.dataset.ivbBound) return;
    sticky.dataset.ivbBound = '1';

    // Single-option products: the floating button adds straight to cart by
    // clicking the inline form's real add-to-cart button, which keeps Horizon's
    // fly-to-cart animation + cart drawer.
    var addBtn = section.querySelector('[data-ivb-sticky-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var atc = section.querySelector('.ivb-product__buybox .ivb-product__atc');
        if (atc) atc.click();
      });
    }

    // Loading spinner on the add-to-cart button while the /cart/add request is
    // in flight (the slow ~1–3s part) so the user sees something is happening.
    // Cleared when the cart updates or errors.
    section.querySelectorAll('.ivb-product__atc').forEach(function (atc) {
      atc.addEventListener('click', function () {
        if (atc.hasAttribute('disabled')) return;
        atc.classList.add('is-adding');
      });
    });
    function clearAdding() {
      section.querySelectorAll('.ivb-product__atc.is-adding').forEach(function (a) {
        a.classList.remove('is-adding');
      });
    }
    document.addEventListener('cart:update', clearAdding);
    document.addEventListener('cart:error', clearAdding);

    // Multiple options: the floating button opens the bottom-sheet popup.
    var sheet = section.querySelector('[data-ivb-sheet]');
    var backdrop = section.querySelector('[data-ivb-sheet-backdrop]');
    if (!sheet || !backdrop) return;

    var openBtn = section.querySelector('[data-ivb-sheet-open]');
    var closeEls = section.querySelectorAll('[data-ivb-sheet-close]');
    var isPhone = function () { return window.matchMedia('(max-width: 749px)').matches; };

    function open() {
      if (!isPhone()) return;
      sheet.classList.add('is-open');
      backdrop.classList.add('is-open');
      sticky.classList.add('is-hidden');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      sheet.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      sticky.classList.remove('is-hidden');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    backdrop.addEventListener('click', close);

    // Drag/swipe up anywhere on the bar (incl. the grip) opens the sheet.
    // Non-passive + preventDefault so the page doesn't scroll under the gesture.
    var dragStartY = null;
    sticky.addEventListener('touchstart', function (e) { dragStartY = e.touches[0].clientY; }, { passive: true });
    sticky.addEventListener('touchmove', function (e) {
      if (dragStartY === null) return;
      e.preventDefault();
      if (dragStartY - e.touches[0].clientY > 24) { dragStartY = null; open(); }
    }, { passive: false });
    sticky.addEventListener('touchend', function () { dragStartY = null; });

    // Drag down by the grip/header closes the sheet (the X still works too).
    // Armed only from the top chrome so it never fights with scrolling the body;
    // preventDefault there stops the page/sheet scrolling under the drag.
    var sheetDragY = null;
    sheet.addEventListener('touchstart', function (e) {
      var fromTop = (e.target.closest && e.target.closest('.ivb-product__sheet-head')) ||
        (e.target.classList && e.target.classList.contains('ivb-product__sheet-grip'));
      sheetDragY = fromTop ? e.touches[0].clientY : null;
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (sheetDragY === null) return;
      e.preventDefault();
      if (e.touches[0].clientY - sheetDragY > 24) { sheetDragY = null; close(); }
    }, { passive: false });
    sheet.addEventListener('touchend', function () { sheetDragY = null; });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) close();
    });

    // Close once the item is in the cart (the cart drawer takes over). Both
    // CartAddEvent and CartUpdateEvent dispatch as 'cart:update' (events.js).
    document.addEventListener('cart:update', function (e) {
      var errored = e && e.detail && e.detail.data && e.detail.data.didError;
      if (!errored) close();
    });

    // Reset if the viewport grows past the breakpoint while the sheet is open.
    window.addEventListener('resize', function () {
      if (!isPhone() && sheet.classList.contains('is-open')) close();
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ivb-product').forEach(setup);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
